import {AxiosResponse} from "axios"
import {ISubjectDTO} from "../types/dtos/ISubjectDTO";
import {IStandardPagedResponse, IStandardResponse, ISubject, TCompanyId} from "../types";
import {apiClient, RetryConfig, createRetryingNotificationHandler} from "./apiClient"

export const loadSubjects = async (companyId: TCompanyId, state: "ACTIVE" | "ARCHIVED" = "ACTIVE"): Promise<Array<ISubject>> => {
    const url = `/companies/${companyId}/subjects?state=${state}`
    const res: AxiosResponse<IStandardPagedResponse<ISubjectDTO>> = await apiClient.get(url,
        {
            retry: true,
            maxRetries: 100,
            backoff: 300,
            onRetry: createRetryingNotificationHandler({message: "Loading Subjects Failed."})
        } as RetryConfig)
    return res.data.data.map(subjectDTOToSubject)
};

export const loadArchivedSubjects = async (companyId: TCompanyId): Promise<Array<ISubject>> => {
    return loadSubjects(companyId, "ARCHIVED")
};

export const createSubject = async (companyId: TCompanyId, subjectDTO: Partial<ISubjectDTO>): Promise<ISubject> => {
    const url = `/companies/${companyId}/subjects`
    const res: AxiosResponse<IStandardResponse<ISubjectDTO>> = await apiClient.post(url, subjectDTO)
    return subjectDTOToSubject(res.data.data)
}

export const updateSubject = async (companyId: TCompanyId, subjectId: string, name: string): Promise<ISubject> => {
    const url = `/companies/${companyId}/subjects/${subjectId}`
    const res: AxiosResponse<IStandardResponse<ISubjectDTO>> = await apiClient.patch(url, {name})
    return subjectDTOToSubject(res.data.data)
}

export const archiveSubject = async (companyId: TCompanyId, subjectId: string): Promise<void> => {
    const url = `/companies/${companyId}/subjects/${subjectId}`
    await apiClient.delete(url)
}

export const restoreSubject = async (companyId: TCompanyId, subjectId: string): Promise<ISubject> => {
    const url = `/companies/${companyId}/subjects/${subjectId}/restore`
    const res: AxiosResponse<IStandardResponse<ISubjectDTO>> = await apiClient.post(url)
    return subjectDTOToSubject(res.data.data)
}

export const subjectDTOToSubject = (dto: ISubjectDTO): ISubject => {
    return {
        id: dto.id,
        name: dto.name,
        createdAt: dto.created_at,
        state: dto.state,
    }
}